function formCheck(){
    var count = $('.c-form-error-text:visible').length;
    var str = '';
    var path = location.pathname
    if (path.slice(0,4) == "/en/"){
        str = 'One or more required fields have not been entered. Please check and try again.'
    } else {
        str = count + '件の未入力項目があります。'
    }
    if(count === 0){
        $('.js-status-count').hide();
    } else if($('.js-status-count').length === 0){
        $('<p class="js-status-count" style="color:#A20915;">' + str + '</p>').insertBefore('.js-form-check');
    } else {
        $('.js-status-count').show();
        $('.js-status-count').text(str);
    }
}

function updateCount(){
    var count = $('.c-form-error-text:visible').length;
    var str = '';
    var path = location.pathname
    if (path.slice(0,4) == "/en/"){
        str = 'One or more required fields have not been entered. Please check and try again.'
    } else {
        str = count + '件の未入力項目があります。'
    }
    if($('.js-status-count').length){
        if(count > 0){
            $('.js-status-count').show();
            $('.js-status-count').text(str);
        } else {
            $('.js-status-count').hide();
        }
    }
}

$('input, select').change(function(){
    setTimeout(function(){
        updateCount();
    },300);
});

export default () => {
  $('.js-form-check').on('mouseup', function(){
    setTimeout(function(){
      formCheck();
    },300);
  })
};

